<template>
  <div>
    <div>
      <h5>Success Page</h5>
    </div>
    <p v-if="!isSuccess" class="title">Verifying your Transaction...</p>
    <div v-if="isSuccess">
      <p class="title">Transaction Successful</p>

      <div class="col-md-6 pl-0">
        <b-form-group class="col-md-10">
          <label class="form-label" for="">Name: </label>
          <input class="form-control" v-model="name" disabled type="text" />
        </b-form-group>
        <b-form-group class="col-md-10">
          <label class="form-label" for="">Amount: </label>
          <input class="form-control" v-model="amount" disabled type="text" />
        </b-form-group>
        <b-form-group class="col-md-10">
          <label class="form-label" for="">Invoice ID: </label>
          <input
            class="form-control"
            v-model="invoice_id"
            disabled
            type="text"
          />
        </b-form-group>
        <button class="btn btn-primary ml-2">Download PDF</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Success",
  data() {
    return {
      isSuccess: false,
    };
  },
  methods: {
    processpayment() {
      this.$store.commit("payment/TOGGLE_LOADING");
      this.$store
        .dispatch("payment/processPayment", {
          sessionID: this.$route.query.session_id,
        })
        .then(({ status, clientID, invoiceNumber }) => {
          this.isSuccess = status;
        })
        .finally(() => {
          this.$store.commit("payment/TOGGLE_LOADING");
        });
    },
  },
  mounted() {
    if (this.$route.query?.session_id) this.processpayment();
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 15px;
  color: black;
}
</style>
